import moment from "moment";
import store from "@/store";

export function startTime(rawStart, rawEnd, callback) {
  const waiting = moment().isBefore(rawStart)
    ? {
      moment: moment(rawStart),
      status: "Open",
      icon: "rocketc",
      color: "#2aba7c",
      text: ""
    }
    : moment().isBefore(rawEnd)
      ? {
        moment: moment(rawEnd),
        status: "Closed",
        icon: "rocketc",
        color: "#C0C0C0",
        text: ""
      }
      : null;

  if (waiting) {
    const diff = waiting.moment.diff(moment(), "seconds");
    let ticker = diff < 24 * 60 * 60 && diff > 0 ? moment.duration(diff, "seconds") : null;
    let timer = ticker ? formatTimer(waiting.text, ticker) : null;
    callback({ timer });

    const intervalHandle = setInterval(() => {
      if (moment().isAfter(waiting.moment)) {
        clearInterval(intervalHandle);
        callback({
          timer: null,
          timerStatus: waiting.status,
          timerIcon: waiting.icon,
          timerColor: waiting.color
        });
        if (waiting.status === "Open") {
          startTime(rawStart, rawEnd, callback);
        }
      }

      if (ticker) {
        ticker = ticker.subtract(1, "seconds");
        callback({ timer: formatTimer(waiting.text, ticker) });
      }
    }, 1000);
  }
}

function formatTimer(text, duration) {
  let time = duration.hours();
  let epilogue = "hours";
  if (time === 0) {
    time = duration.minutes();
    epilogue = "minutes";
    if (time === 0) {
      time = duration.seconds();
      epilogue = "seconds";
    }
  }
  return `${text} ${time} ${epilogue}`;
}

function formatDate(duration) {
  const lang = store.getters.language;
  let time = duration.days();
  let epilogue;

  if (time > 0) {
    if (lang === "en") {
      epilogue = time === 1 ? "day" : "days";
    }
    else {
      epilogue = getRussianPlural(time, ["день", "дня", "дней"]);
    }
    return `${time} ${epilogue}`;
  }

  time = duration.hours();
  if (time > 0) {
    if (lang === "en") {
      epilogue = time === 1 ? "hour" : "hours";
    }
    else {
      epilogue = getRussianPlural(time, ["час", "часа", "часов"]);
    }
    return `${time} ${epilogue}`;
  }

  time = duration.minutes();
  if (time > 0) {
    if (lang === "en") {
      epilogue = time === 1 ? "minute" : "minutes";
    }
    else {
      epilogue = getRussianPlural(time, ["минута", "минуты", "минут"]);
    }
    return `${time} ${epilogue}`;
  }

  time = duration.seconds();
  if (lang === "en") {
    epilogue = time === 1 ? "second" : "seconds";
  }
  else {
    epilogue = getRussianPlural(time, ["секунда", "секунды", "секунд"]);
  }
  return `${time} ${epilogue}`;
}

// Функция для склонения русских слов в зависимости от числа
function getRussianPlural(number, titles) {
  const cases = [2, 0, 1, 1, 1, 2];
  return titles[
    number % 100 > 4 && number % 100 < 20
      ? 2
      : cases[number % 10 < 5 ? number % 10 : 5]
  ];
}

export function timeToRelease({ dateToStart, dateToRelesse }) {
  if (!dateToStart) {
    dateToStart = moment();
  }
  else {
    dateToStart = moment(dateToStart);
  }

  const releaseDate = moment(dateToRelesse);

  const diffInMs = releaseDate - dateToStart;
  if (diffInMs < 1) {
    return "-";
  }
  const duration = moment.duration(diffInMs);

  return formatDate(duration);
}